import { ProductAvailabilityStore } from "@/api/generatedTypes";

import styles from "./CityStores.module.scss";

const LOW_THRESHOLD = 3;

interface CityStoresProps {
  stores: ProductAvailabilityStore[];
}

const CityStores = ({ stores }: CityStoresProps) => (
  <>
    {stores.map((store) => {
      const isAllSizesOutOfStock = store.sizes?.every(
        (item) => +item.count === 0
      );

      return (
        <div key={store.id} className={styles.storeCard}>
          <p className={styles.address}>{store.address}</p>
          <p className={styles.metro}>{store?.metro}</p>
          <div className={styles.sizesContainer}>
            {isAllSizesOutOfStock && (
              <p className={styles.sizeLabel}>Нет в наличии</p>
            )}
            {store.sizes?.map((size) => {
              const isLow = +size.count <= LOW_THRESHOLD;
              const isOutOfStock = +size.count === 0;

              if (isOutOfStock) return null;

              return (
                <div key={size.id}>
                  <p className={styles.sizeLabel}>{size.size}</p>
                  {isLow && <p className={styles.sizeLow}>мало</p>}
                </div>
              );
            })}
          </div>
        </div>
      );
    })}
  </>
);

export default CityStores;
